import { ResetWebSearchFiltersButton } from 'reactApp/ui/Toolbar/ResetWebSearchFiltersButton';
import type { ToolbarItem, TToolbarItem } from 'reactApp/ui/Toolbar/Toolbar.types';
import { useWebSearchFilters } from 'reactApp/ui/WebSearch/hooks/useWebSearchFilters';

export const getResetWebSearchFiltersItem = (): TToolbarItem => ({
    Item: ResetWebSearchFiltersButton as ToolbarItem,
    itemProps: { hook: useWebSearchFilters },
});
